/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CountryGroupResponse } from '../../models/country-group-response';

export interface CountryControllerGetGroupsAndCountries$Params {
}

export function countryControllerGetGroupsAndCountries(http: HttpClient, rootUrl: string, params?: CountryControllerGetGroupsAndCountries$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CountryGroupResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, countryControllerGetGroupsAndCountries.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CountryGroupResponse;
      }>;
    })
  );
}

countryControllerGetGroupsAndCountries.PATH = '/country/group';
